



import { FontIcon } from "@/components/fluent-icon-compat";
import { makeStyles, mergeStyles, shorthands } from "@/components/fluent-styles-compat";
const useStyles = makeStyles({
  avatar: {
    width: "40px",
    height: "40px",
    ...shorthands.borderRadius("50%"),
    backgroundColor: "transparent",
  },
  avatarImage: {
    width: "100%",
  },
});

const iconClass = mergeStyles({
  fontSize: 30,
  height: 30,
  width: 30,
  // Prefer the logged-in tenant's themed secondary colour (set by Theme.tsx as
  // --theme-secondary-light); fall back to the static brand colour when no
  // tenant theme is applied.
  color: "var(--theme-secondary-light, var(--secondary-color-light))",
});

export const BotAvatar = ({ style = {} }) => {
  useStyles();

  return (
    <FontIcon
      aria-label="Lightbulb"
      iconName="Lightbulb"
      className={iconClass}
      style={style}
    />
    // <div className="react-chatbot-kit-chat-bot-avatar">
    //   <div className="react-chatbot-kit-chat-bot-avatar-container">
    //     <div className={styles.avatar}>
    //       <img src="./icons/logo.png" alt="avatar" className={styles.avatarImage} />
    //     </div>
    //   </div>
    // </div>
  );
};
